import type { CuratedCopy } from "./preview-copy.types";
export const godsOfTheArenaCopy: CuratedCopy = {
  blurb:
    "Two teams of five heroes fight to slay the enemy god. Draft heroes, buy items and push lanes, with a program that plays every seat. Win as a team to climb the ladder.",
  beats: () => [
    {
      title: "Five heroes a side",
      body: "Each team fields five heroes and one god. The match ends when a god falls.",
    },
    {
      title: "Your program plays every seat",
      body: "Your program is a file Gods of the Arena runs for the whole match, with no live input from you.",
    },
    {
      title: "Team results only",
      body: "The ladder counts only team wins, losses and draws. Kills and XP do not move your rating.",
    },
  ],
  docs: {
    title: "Wiki",
    subtitle: "How the coworld works",
    page: "game-guide",
  },
};
